import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./wtf-forms.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ReactNotifications className='app-notification' />
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
